import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import ReactMarkdown from "react-markdown";
import { MapPin, CircleNotch, Sparkle } from "@phosphor-icons/react";

export default function LocalSeo() {
  const [loading, setLoading] = useState(false);
  const [plan, setPlan] = useState(null);

  const generate = async () => {
    setLoading(true);
    try {
      const r = await api.localSeo();
      setPlan(r.data.plan);
      toast.success("Toronto local SEO plan ready");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="fade-up space-y-6 max-w-5xl">
      <div className="border p-6 bg-[var(--surface)] flex flex-col sm:flex-row sm:items-center justify-between gap-4" style={{ borderColor: "var(--line)" }}>
        <div className="flex items-start gap-4">
          <div className="w-11 h-11 flex items-center justify-center shrink-0" style={{ background: "#0b1220", borderRadius: 3 }}>
            <MapPin size={24} weight="duotone" color="var(--accent)" />
          </div>
          <div>
            <h2 className="text-base font-bold">Toronto Local SEO</h2>
            <p className="text-sm" style={{ color: "var(--text-2)" }}>Local keywords, link-building targets, GBP checklist & content ideas for the Toronto market.</p>
          </div>
        </div>
        <button data-testid="generate-local-seo-button" onClick={generate} disabled={loading} className="px-6 py-3 text-sm font-bold flex items-center gap-2 justify-center text-white disabled:opacity-60 hover:opacity-90 transition-opacity shrink-0" style={{ background: "var(--primary)" }}>
          {loading ? <CircleNotch size={17} className="animate-spin" /> : <Sparkle size={17} weight="bold" />}
          {loading ? "Analyzing…" : "Generate Plan"}
        </button>
      </div>

      {loading && (
        <div className="border p-16 text-center bg-[var(--surface)]" style={{ borderColor: "var(--line)" }}>
          <CircleNotch size={30} className="animate-spin mx-auto mb-3" color="var(--accent)" />
          <p className="mono text-sm" style={{ color: "var(--text-2)" }}>Building your Toronto local SEO strategy…</p>
        </div>
      )}

      {plan && (
        <div className="border p-6 bg-[var(--surface)] prose-cs text-sm" style={{ borderColor: "var(--line)" }} data-testid="local-seo-plan">
          <ReactMarkdown>{plan}</ReactMarkdown>
        </div>
      )}
    </div>
  );
}
